import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=ee9d215a&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=ee9d215a&prod&lang=scss&scoped=true"
import style1 from "./Wallet.vue?vue&type=style&index=1&id=ee9d215a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9d215a",
  null
  
)

export default component.exports